import { FC } from "react";
import { ChevronDownIcon } from "./svg/ChevronDownIcon";
import { HistoryIcon } from "./svg/HistoryIcon";
import { SettingsIcon } from "./svg/SettingsIcon";
import { TabHighlight } from "./svg/TabHighlight";

export const TradeToken: FC<{ className?: string }> = ({ className }) => {
  return (
    <div
      className={`flex flex-col gap-5 bg-[rgba(9,20,30,0.9)] rounded-2xl p-[20px] w-full max-w-full ${className || ""}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-16 text-white font-bold text-base">
          <div className="relative">
            <div>Buy</div>
            <TabHighlight className="absolute left-0 -bottom-1" />
          </div>
          <div>
            <div>Sell</div>
          </div>
        </div>
        <div className="flex items-center gap-5">
          <SettingsIcon />
          <HistoryIcon />
        </div>
      </div>

      <div className="flex flex-col gap-[10px]">
        <div className="flex flex-col rounded-lg overflow-hidden">
          <div className="flex items-center bg-[rgba(255,255,255,0.05)]">
            <div className="flex-1 w-1/2 flex items-center gap-2 p-4 border-r border-solid border-[rgba(255,255,255,0.1)]">
              <img
                src="https://xswap.link/assets/tokens/1_0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48_USDC.webp"
                alt="Token logo"
                className="w-[34px] min-w-[34px] max-w-[34px] h-[34px] min-h-[34px] max-h-[34px] rounded-full"
              />
              <div className="flex flex-col gap-1">
                <div className="font-normal text-sm text-[rgba(255,255,255,0.6)]">
                  Token:
                </div>
                <div className="font-medium text-base text-white">
                  Polytrade
                </div>
              </div>
            </div>

            <div className="flex-1 w-1/2 p-4 flex items-center justify-between">
              <div className="flex flex-col gap-1">
                <div className="font-normal text-sm text-[rgba(255,255,255,0.6)]">
                  Chain:
                </div>
                <div className="font-medium text-base text-white">Polygon</div>
              </div>

              <ChevronDownIcon />
            </div>
          </div>

          <div className="flex items-center justify-between p-4 bg-[rgba(85,166,251,0.1)]">
            <div className="text-white text-xl font-bold">24 000</div>
            <div className="text-[rgba(255,255,255,0.6)] text-xl font-medium">
              USD
            </div>
          </div>
        </div>

        <div className="rounded-lg overflow-hidden">
          <div className="bg-[rgba(255,255,255,0.1)]"></div>
          <div className="bg-[rgba(85,166,251,0.1)] font-bold text-xl text-[#007DFF] p-4">
            128 000
          </div>
        </div>
      </div>

      <div className="p-4 text-white text-sm font-medium bg-[rgba(255,255,255,0.05)] rounded-lg">
        <div className=" whitespace-nowrap overflow-hidden text-ellipsis max-w-80 sm:max-w-full">
          Receiving wallet: 0xfeac14b1f39b63caf126b232bef7c87179b12834
        </div>
      </div>
      <button className="p-4 flex items-center justify-center text-white text-base font-medium bg-gradient-to-l from-[#55A6FB] to-[#006AD9] rounded-lg">
        Buy
      </button>
    </div>
  );
};
